// services/sys-role.service.ts
import axios from "../../department-viags/config.service";

export interface SysRole {
  id: string; // Guid
  code: string;
  name: string;
  description?: string;
  isDeleted: boolean;
  createdDate: Date;
  updatedDate?: Date;
  creator?: string;
  updater?: string;
  createdBy?: string; // Guid
  updatedBy?: string; // Guid
}

export interface SysRoleRequest {
  name: string;
  description?: string;
}

type ApiResponse<T> = { data: T; statusCode: number };

const BASE = "/api/qltl/sysrole";

export class SysRoleService {
  /**
   * GET /GetRoles
   */
  static async getRoles(keyword: string | undefined, pageIndex: number, pageSize: number) {
    try {
      const res = await axios.get<ApiResponse<{ items: SysRole[]; total: number }>>(`${BASE}/GetRoles`, {
        params: { keyword, pageIndex, pageSize },
      });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.error(error);
    }
  }

  /**
   * GET /GetDetailRole?id={id}
   */
  static async getDetailRole(id: string) {
    try {
      const res = await axios.get<ApiResponse<SysRole>>(`${BASE}/GetDetailRole`, {
        params: { id },
      });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.error(error);
    }
  }

  /**
   * POST /CreateRole
   */
  static async createRole(req: SysRoleRequest) {
    const res = await axios.post<ApiResponse<boolean>>(`/qltl/sysrole/createrole`, req);
    if (res.data.statusCode !== 200) return;
    return res.data.data;
  }

  /**
   * PUT /UpdateRole/{id}
   */
  static async updateRole(id: string, req: SysRoleRequest) {
    try {
      const res = await axios.put<ApiResponse<boolean>>(`${BASE}/UpdateRole/${id}`, req);
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.error(error);
    }
  }

  /**
   * DELETE /DeleteRole/{id}
   */
  static async deleteRole(id: string) {
    try {
      const res = await axios.delete<ApiResponse<boolean>>(`${BASE}/DeleteRole/${id}`);
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.error(error);
    }
  }
}
